import api from "./api";

const quoteService = {
  /**
   * Obtiene cotizaciones con paginación y filtros opcionales
   */
  async fetchQuotes(page = 1, fromDate = null, toDate = null, search = null) {
    let url = `/quotes?page=${page}`;

    if (fromDate && toDate) {
      url += `&from=${fromDate}&to=${toDate}`;
    }

    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const response = await api.get(url);
    return response.data;
  },

  /**
   * Obtiene el detalle completo de una cotización
   */
  async getQuote(id) {
    const response = await api.get(`/quotes/${id}`);
    return response.data;
  },

  /**
   * Crea una nueva cotización
   * @param {Object} payload { cliente_nombre, cliente_telefono, cliente_direccion, cliente_email, fecha_vigencia, notas, descuento, items }
   */
  async createQuote(payload) {
    const response = await api.post("/quotes", payload);
    return response.data;
  },

  /**
   * Descarga el PDF de una cotización
   */
  async downloadPdf(id) {
    const response = await api.get(`/quotes/${id}/pdf`, {
      responseType: "blob",
    });
    return response.data;
  },

  /**
   * Elimina (soft delete) una cotización
   */
  async deleteQuote(id) {
    const response = await api.delete(`/quotes/${id}`);
    return response.data;
  },
};

export default quoteService;